import { createTemperature, temperatureToCelsius, temperatureToFahrenheit } from 'measure-fns';
import { ConversionOptions } from 'measure-fns/dist/interfaces';

export const convertTemperature = (
  rawTemperature: number,
  unit: string | undefined,
  options: ConversionOptions = { round: 1 },
): string => {
  const resolvedUnit = unit ?? 'F';
  const temperature = createTemperature(rawTemperature);
  switch (resolvedUnit) {
    case 'C':
      return `${temperatureToCelsius(temperature, options)} °C`;
    case 'F':
      return `${temperatureToFahrenheit(temperature, options)} °F`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
